import Persistable from "../../storage/persistable";

export default class Player extends Persistable {
    constructor(teamId, uniform, positions = [], firstName, lastName) {
        super();
        this.playerId = null;
        this.teamId = teamId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.uniform = uniform;
        this.positions = positions;
        this.deleted = false;
    }

    markDeleted() {
        this.deleted = true;
    }

    restore() {
        this.deleted = false;
    }

    addPosition(position) {
        this.positions.push(position);
    }

    removePosition(position) {
        const index = this.positions.findIndex(
            (pos) => pos.code === position.code
        );
        if (index >= 0) {
            this.positions.splice(index, 1);
        }
    }

    toString() {
        let ret = "";
        if (this.uniform) {
            ret += `#${this.uniform} `;
        }
        if (this.firstName) {
            ret += `${this.firstName.substring(0, 1)}. `;
        }
        if (this.lastName) {
            ret += this.lastName;
        }
        return ret.trim();
    }
}
